import { ApiResponse, TokenData, IBank } from '../models';
import * as http from './http';
import ApiService from './service';

export class BankService extends ApiService {
  public async loadAllBanks(): Promise<IBank[]> {
    const url = `${this.apiDomain}/api/bank`;

    const resposne = await http.get<ApiResponse<IBank[]>>(url, this.store);
    return resposne?.data?.data;
  }

  public async updateBank(data: IBank, id?: string) {
    const url = `${this.apiDomain}/api/bank/${id}`;

    const response = await http.put<ApiResponse<IBank>>(url, data, this.store);
    return response.data;
  }

  public async createBank(data: IBank) {
    const url = `${this.apiDomain}/api/bank`;

    const response = await http.post<ApiResponse<IBank>>(url, data, this.store);
    return response.data;
  }

  public async deleteBank(id?: string) {
    const url = `${this.apiDomain}/api/bank/${id}`;

    const response = await http.remove<ApiResponse<IBank>>(url, this.store);
    return response.data;
  }
}
